var map = {
	"./adult/nn/ordforstaelse-data.json": 837,
	"./adult/no/ordforstaelse-data.json": 838,
	"./adult/se/ordforstaelse-data.json": 839,
	"./youth/de/ordforstaelse-data.json": 840,
	"./youth/nn/ordforstaelse-data.json": 841,
	"./youth/no/ordforstaelse-data.json": 842,
	"./youth/se/ordforstaelse-data.json": 843
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;